<template>
    <div class="modal fade" id="modalAjoutLabel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                        <i class="fa fa-tag" :class="getLabelClass(label.nom)"></i>
                        Ajouter le label {{ label.nom }} ({{ label.niveau }} étoile{{ label.niveau > 1 ? 's' : '' }})
                    </h4>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitForm">
                        <div class="form-group">
                            <label>Niveau du label</label>
                            <select class="form-control" v-model="formData.niveau" required>
                                <option v-for="n in getNiveauxEligibles" :key="n" :value="n">
                                    {{ n }} étoile{{ n > 1 ? 's' : '' }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Date de début</label>
                            <input type="date" class="form-control" v-model="formData.date_debut" required>
                        </div>
                        <div class="form-group">
                            <label>Date de fin</label>
                            <input type="date" class="form-control" v-model="formData.date_fin" required>
                        </div>
                        <div class="form-group">
                            <label>Commentaire (optionnel)</label>
                            <textarea class="form-control" v-model="formData.commentaire" rows="3"></textarea>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Annuler</button>
                    <button type="button" class="btn btn-primary" @click="submitForm" :disabled="loading || !formData.niveau">
                        <i class="fa" :class="loading ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                        Enregistrer
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'ModalAjoutLabel',
    props: {
        clubId: {
            type: [String, Number],
            required: true
        },
        label: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            formData: {
                niveau: null,
                date_debut: '',
                date_fin: '',
                commentaire: ''
            }
        }
    },
    mounted() {
        this.initialiserDates();
    },
    methods: {
        initialiserDates() {
            const aujourdhui = new Date();
            const dansDeuxAns = new Date();
            dansDeuxAns.setFullYear(aujourdhui.getFullYear() + 2);

            // Formater les dates au format YYYY-MM-DD pour les inputs de type date
            this.formData.date_debut = aujourdhui.toISOString().split('T')[0];
            this.formData.date_fin = dansDeuxAns.toISOString().split('T')[0];
        },
        getLabelClass(labelNom) {
            switch(labelNom) {
                case 'Art Martial':
                    return 'label-art-martial';
                case 'Kyorugi':
                    return 'label-kyorugi';
                case 'Poomsae':
                    return 'label-poomsae';
                default:
                    return 'label-commun';
            }
        },
        submitForm() {
            this.loading = true;
            const data = {
                club_id: +this.clubId,
                niveau: this.formData.niveau,
                date_debut: this.formData.date_debut,
                date_fin: this.formData.date_fin,
                commentaire: this.formData.commentaire,
                label_id: this.label.id
            };

            this.$http.post(this.getRoute('Labelisation.addLabelToClub'), data)
                .then(() => {
                    $('#modalAjoutLabel').modal('hide');
                    this.$emit('label-ajoute');
                })
                .catch(error => {
                    console.error('Erreur lors de l\'ajout du label:', error);
                    alert('Une erreur est survenue lors de l\'ajout du label');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    computed: {
        ...mapGetters({
            getRoute: 'getRoute',
        }),
        getNiveauxEligibles() {
            return [1, 2, 3];
        }
    }
}
</script>

<style scoped>
.modal-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-title i {
    font-size: 18px;
}

.label-art-martial {
    color: #007bff;
}

.label-kyorugi {
    color: #dc3545;
}

.label-poomsae {
    color: #6f42c1;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 5px;
}

textarea.form-control {
    resize: vertical;
    min-height: 80px;
}
</style> 


// WEBPACK FOOTER //
// src/components/Secretariat/Club/ModalAjoutLabel.vue